module.exports = __webpack_public_path__ + "img/play_color.00e5aca2.svg";